function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1905 59c-22 5-46 9-73 9-117 0-125-57-219-57-93 0-188 57-262 57-17 0-127-64-217-64-185 0-223 61-325 60-51-18-94-60-190-60-124 0-174 64-292 64-117 0-125-57-219-57-36 0-72 9-108 19v199h1905V59z",
  fill: "#25A8C1"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M1000 19a1040 1040 0 0169-11 450 450 0 01138 9l32 10 16 6 8 3 8 2c-38-16-79-37-154-37-47 0-83 8-117 18zM506 23l8-1 8-2a505 505 0 01117-9 309 309 0 0196 21l15 6 8 2 8 3C729 27 690 5 618 5c-46 0-80 9-112 18z",
  fill: "#69BCB8"
});

var SvgSeaWave5 = function SvgSeaWave5(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 1905,
    height: 230,
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSeaWave5, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sea-wave-5.283da139.svg";
export { ForwardRef as ReactComponent };